import { cacheDependencyMap } from "@/services/cachingSystem/cacheDependencyMap";
import type { DependencyStackItem } from "@/services/cachingSystem/resolveCacheDependenciesArr";

export const resolveCacheDependenciesStack = (eventName: string) => {
	const dependencies = cacheDependencyMap[eventName] || [];

	// Loop the dependencies
	return dependencies.map((dependency) => {
		const dependencyStackItem: DependencyStackItem = {
			name: dependency,
			deps: resolveCacheDependenciesStack(dependency)
		};
		return dependencyStackItem;
	});
};
